import * as ITEM_STATUSES from 'swag-common/constants/item-statuses.constants';
import { ORDER_INDICATORS_NAMES } from 'swag-common/constants/order-indicators-names';
import { ORDER_ITEMS_TYPES } from 'swag-common/constants/order-statuses.constants';
import { isBundleItem } from 'swag-common/utils/custom-store-product/product-is-bundle.util';
import { isItemBlankSample, isItemPrintedSample } from 'swag-common/utils/items/is-item-sample.service';
import { checkIsSwagOrResellerInventoryOrder } from 'swag-common/utils/order/check-is-swag-or-reseller-inventory-order.util';
import { getCheapestShipmentCharge } from 'swag-common/utils/order/get-cheapest-shipment-charge.util';
import { isCustomStoreOrder } from 'swag-common/utils/order/is-custom-store-order.util';
import { isItemInBox } from 'swag-common/utils/order/is-item-in-box.util';
import { isItemSampleBox } from 'swag-common/utils/order/is-item-sample-box.util';
import { isItemGiveawayNotecard } from 'swag-common/utils/order/item-is-box.util';
import { checkIsSilentOrder } from './check-is-silent-order.util';
import { isFirstInventoryOrder } from './is-first-inventory-order.util';
import { isInternationalOrder } from './is-international-order.util';
// Helpers
const hasPendingItems = items => items.some(item => item.status === ITEM_STATUSES.PENDING_APPROVAL);
const isRushedDelivery = (items = []) => {
  let isRushed = false;
  items.forEach(item => {
    const cheapestShipmentRate = getCheapestShipmentCharge(item);
    if (cheapestShipmentRate && item.serviceCode !== cheapestShipmentRate.serviceCode) {
      isRushed = true;
    }
  });
  return isRushed;
};
const getRushedProductionItem = item => {
  return item.prodTime > 0 && !item.isSample && !item.isPrintedSample;
};
const isRushedProduction = (items = []) => {
  const itemsWithRushedProduction = items.filter(getRushedProductionItem);
  return itemsWithRushedProduction.length > 0;
};
export function getOrderIndicatorsNames(order) {
  var _order$itemTypes, _order$itemTypes2;
  const indicators = [];
  if (isCustomStoreOrder(order)) {
    indicators.push(ORDER_INDICATORS_NAMES.CUSTOM_STORE_ORDER);
  }
  if (checkIsSwagOrResellerInventoryOrder(order, false)) {
    indicators.push(ORDER_INDICATORS_NAMES.INVENTORY_ORDER);
    const distributionIcon = order.distributeOption && ORDER_INDICATORS_NAMES[order.distributeOption];
    if (distributionIcon) {
      indicators.push(distributionIcon);
    }
  }
  if (isFirstInventoryOrder(order)) {
    indicators.push(ORDER_INDICATORS_NAMES.FIRST_INVENTORY_ORDER);
  }
  if (order.items.some(isBundleItem)) {
    indicators.push(ORDER_INDICATORS_NAMES.BUNDLE_ORDER);
  }
  if (isInternationalOrder(order)) {
    indicators.push(ORDER_INDICATORS_NAMES.INTERNATIONAL_ORDER);
  }
  if (order.items.some(isItemInBox) || order.items.some(isItemSampleBox)) {
    indicators.push(ORDER_INDICATORS_NAMES.BOX_ORDER);
  }
  if (order.items.some(isItemBlankSample)) {
    indicators.push(ORDER_INDICATORS_NAMES.BLANK_SAMPLE_ORDER);
  }
  if (order.items.some(isItemPrintedSample)) {
    indicators.push(ORDER_INDICATORS_NAMES.PRINTED_SAMPLE_ORDER);
  }
  if (isRushedProduction(order.items)) {
    indicators.push(ORDER_INDICATORS_NAMES.RUSHED_PRODUCTION_ORDER);
  }
  if (isRushedDelivery(order.items)) {
    indicators.push(ORDER_INDICATORS_NAMES.RUSHED_DELIVERY_ORDER);
  }
  if (hasPendingItems(order.items)) {
    indicators.push(ORDER_INDICATORS_NAMES.PENDING_APPROVAL);
  }
  if (order.isDummyOrder) {
    indicators.push(ORDER_INDICATORS_NAMES.DUMMY_ORDER);
  }
  if (order.items.some(isItemGiveawayNotecard)) {
    indicators.push(ORDER_INDICATORS_NAMES.GIVEAWAY_NOTECARD);
  }
  if ((_order$itemTypes = order.itemTypes) !== null && _order$itemTypes !== void 0 && _order$itemTypes.includes(ORDER_ITEMS_TYPES.EXPIRABLE_PRODUCTS)) {
    indicators.push(ORDER_INDICATORS_NAMES.EXPIRABLE_PRODUCTS);
  }
  if ((_order$itemTypes2 = order.itemTypes) !== null && _order$itemTypes2 !== void 0 && _order$itemTypes2.includes(ORDER_ITEMS_TYPES.REPLACEMENT)) {
    indicators.push(ORDER_INDICATORS_NAMES.REPLACEMENT_ORDER);
  }
  if (order.isSplitShipped) {
    indicators.push(ORDER_INDICATORS_NAMES.SPLIT_SHIPPED);
  }
  if (checkIsSilentOrder(order)) {
    indicators.push(ORDER_INDICATORS_NAMES.IS_SILENT);
  }
  return indicators;
}
export const getItemNameLabel = isRelatedItem => {
  if (isRelatedItem) {
    return 'Associated product';
  }
  return '';
};